import { Box, Container, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import InputTextfield from "../../../../shared/components/textField";
import useMutation from "../../../../shared/components/hooks/useMutation";
import { getValidationSchema } from "../../../../shared/validations/schema";
import ForgotPasswordBg from "../../../../assets/img/forgot-password.svg";
import LoginPageCard from "../../../../shared/components/auth/loginPageCard";
import MenuContainer from "../../../../shared/components/auth/menuContainer";
import LoginRightPanelComponent from "../../../../shared/components/auth/loginRightPanel";

const ForgotPassword = () => {
  const { loading, modifyData } = useMutation();

  const textFields = [
    {
      id: "email",
      name: "email",
      label: "Email Address",
      placeholder: "Enter your email address",
      type: "text",
    },
  ];

  const forgotPasswordForm = useFormik({
    initialValues: {
      email: "",
    },
    validateOnBlur: true,
    validationSchema: getValidationSchema(["email"]),
    onSubmit: async (formData: any) => {
      const response = await modifyData(
        `/user/send-password-reset-link`,
        "post",
        formData
      );
      if (response) forgotPasswordForm.resetForm();
    },
  });

  return (
    <>
      <Box sx={{ height: "100%", width: "100%" }}>
        <Container>
          <Grid
            container
            sx={{
              justifyContent: "center",
              alignItems: "end",
              padding: "24px",
              marginTop: "4%",
            }}
          >
            <Grid item md={4}>
              <LoginPageCard padding=" 20% 8% 20% 10%">
                <MenuContainer />
                <form
                  onSubmit={forgotPasswordForm.handleSubmit}
                  autoComplete="off"
                >
                  <InputTextfield
                    form={forgotPasswordForm}
                    fieldProps={textFields[0]}
                  />
                  <Grid item md={12} sx={{ mt: 2 }}>
                    <LoadingButton
                      loading={loading}
                      variant="contained"
                      type="submit"
                      fullWidth
                      size="small"
                    >
                      Submit
                    </LoadingButton>
                  </Grid>
                </form>
                {/* <NavLink
                  to="/reset-success"
                  className="forgot-password-link"
                  aria-label="Forgot your password? Click here to reset it."
                >
                  Success
                </NavLink> */}
              </LoginPageCard>
            </Grid>
            <Grid item md={4.5}>
              <LoginRightPanelComponent
                imageSrc={ForgotPasswordBg}
                text=""
                title="Forgot your Password ?"
                subtitle=""
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default ForgotPassword;
